import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/core/services/language.service';
import { Language, LANGUAGES } from 'src/app/core/constants/language-and-locale-constants';
@Component({
  selector: 'emp-language-menu',
  templateUrl: './language-menu.component.html',
  styleUrls: ['./language-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule]
})
export class LanguageMenuComponent {
  public languageService = inject(LanguageService);

  public languages = LANGUAGES;

  public changeLanguage(language: Language): void {
    this.languageService.setLanguage(language);
  }
}
